import {
    BookingReason,
    BookingReasons,
} from '@raskrask-dk/bookingflow-state-machine'

export const isTypeArray = (array: Array<unknown>, str: string): boolean => {
    let hasElseType = false
    array.forEach((item) => {
        if (typeof item !== str) {
            hasElseType = true
        }
    })

    return !hasElseType && array.length > 0
}

/**
 * Checks if given item is in array and:
 * - Adds it if it's new
 * - Removes it if it's existing
 *
 * @param array to add/remove given item from
 * @param item
 * @returns the input array MODIFIED
 */
export const arrayToggleItem = <T>(array: Array<T>, item: T) => {
    const itemIndex = array.indexOf(item)
    if (itemIndex > -1) array.splice(itemIndex, 1)
    else array.push(item)
    return array
}

export const arrayToggleBookingReasonsItem = (
    array: BookingReasons,
    item: BookingReason
) => {
    const itemIndex = array.map((i) => i.id).indexOf(item.id)
    if (itemIndex > -1) array.splice(itemIndex, 1)
    else array.push(item)
    return array
}
